module.exports = __webpack_public_path__ + "static/img/图层 24.8f5d3bd2.png";